import { useLocation } from "react-router-dom";
import { Wrench } from "lucide-react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { useAuth } from "@/context/AuthContext";
import { isStaff } from "@/lib/roles";
import { Card, CardContent } from "@/components/ui/card";

const PATH_TO_KEY = {
  "/": "home",
  "/reglement": "reglement",
  "/forum": "forum",
  "/boutique": "boutique",
  "/sanctions": "sanctions",
  "/tickets": "tickets",
};

function currentKey(pathname) {
  if (PATH_TO_KEY[pathname]) return PATH_TO_KEY[pathname];
  if (pathname.startsWith("/forum")) return "forum";
  if (pathname.startsWith("/boutique")) return "boutique";
  if (pathname.startsWith("/tickets")) return "tickets";
  return null;
}

export default function MaintenanceGate({ children }) {
  const { data: cfg } = useSiteConfig();
  const { user } = useAuth();
  const location = useLocation();
  if (!cfg) return children;

  // Never block admin/auth routes for staff to keep access
  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth")) return children;
  if (isStaff(user)) return children;

  const key = currentKey(location.pathname);
  const blocked = cfg.maintenance_all || (key && cfg.maintenance_pages && cfg.maintenance_pages.includes(key));
  if (!blocked) return children;

  return (
    <div className="max-w-lg mx-auto py-24 px-4">
      <Card className="border-primary/40">
        <CardContent className="p-8 text-center">
          <Wrench className="h-12 w-12 mx-auto text-primary mb-4 animate-pulse" />
          <p className="font-display uppercase text-2xl mb-2">Maintenance en cours</p>
          <p className="text-muted-foreground text-sm whitespace-pre-wrap">
            {cfg.maintenance_message || "Cette section est momentanément fermée pour maintenance. Merci de votre patience."}
          </p>
          <p className="text-xs text-muted-foreground mt-6 font-mono-tech">RiverSide Roleplay · Retour très bientôt.</p>
        </CardContent>
      </Card>
    </div>
  );
}
